import { c as _c } from "react/compiler-runtime";
import { CAMPAIGNS_API } from 'modules/campaigns/api/constants';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import { CampaignInterface } from '../types/campaign-interface';
export const useUpdateSenderEmailAddress = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.put
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  let t1;
  if ($[1] !== fetcher) {
    t1 = {
      updateSenderEmailAddress: (id, senderEmailAddress) => fetcher(`${CAMPAIGNS_API}/${id}/sender-email-address`, {
        senderEmailAddress
      })
    };
    $[1] = fetcher;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};